<template>
  <el-upload
             :file-list="fileList"
             :on-remove="handleRemove"
             :http-request="uploading"
             :limit="1"
             :headers="headers"
             :data="data"
             list-type="picture-card"
             :show-file-list="true"
             :auto-upload="true">
    <el-icon><Plus /></el-icon>

  </el-upload>
</template>

<script setup>
import { base_img } from '../../api/config'
import OSS from "ali-oss"
import {ref, toRefs} from "vue";
import {useStore} from "vuex";
import {getFileExt} from "../../utils/file_util"

const store = useStore()
const disabled = ref(false)
const imageUrl = ref("")
const headers = {token:store.getters.token};
const data = {uploadType:"banner",durable:1};
const fileList = ref([])
let credentials = null; // STS凭证
let ossClient = null; // oss客户端实例
const bucket = 'birdseye'; // bucket名称
const region = 'oss-cn-guangzhou'; // oss服务区域名称

const props = defineProps({
  limit:{
    type: Number,
    default: 1,
  },
  fullPath:{
    type: Boolean,
    default: false,
  },
  url: {
    type: String,
    default: null,
  },
  name: {
    type: String,
    default: new Date().getTime(),
  },
  filename: {
    type: String,
    default: new Date().getTime(),
  }
});
if(props.url){
  fileList.value.push({name:props.name,url:props.url})
}


function getFileName(url) {
  return  new Date().getTime() + url.substring(url.lastIndexOf("."))
}

const emit = defineEmits(["uploadSuccess","handleRemove"]);

const handleRemove = (file) => {
  emit("handleRemove", props.name);
}

async function uploading(option){
  if (!ossClient) {
    await initOSSClient();
  }
  let file = option.file
  let ext = getFileExt(file.name)
  let fileName = props.filename+"."+ext;

  return ossClient.put(fileName, file).then(result => {
    emit("uploadSuccess", props.fullPath? `${base_img}/${result.name}` : result.name, props.name);
  }).catch(err => {
    console.log(`Common upload ${file.name} failed === `, err);
  });
}

function getCredential() {
  return VE_API.ali.credential()
      .then( ({data})=> {
        credentials = data;
        initOSSClient()
      })
}
getCredential()

async function initOSSClient() {
  const { accessKeyId, accessKeySecret, securityToken } = credentials;
  ossClient = new OSS({
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: securityToken,
    bucket,
    region
  });
}

</script>

<style scoped>

</style>
